import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Label, FormGroup } from 'reactstrap';
import PostCategoriesField from '../../../../PostCategoriesField/PostCategoriesField';
import { Field } from 'redux-form';
import PercentageField from '../../../../PercentageField/PercentageField';

const CarouselSettings = ({ env, screen, widget, postCategories }) => {
    const { t } = useTranslation();

    return (
        <>
            <FormGroup row className="widget-setting">
                <Label className="col-sm-4">
                    { t('settings.mobile.screens.widget.settings.post_category_id') }
                </Label>
                <Col sm={ 8 }>
                    <PostCategoriesField
                        postCategories={ postCategories }
                        name={ `mobile.screens.${screen}.widgets[${widget.index}].categoryId` }
                    />
                </Col>
            </FormGroup>
            <FormGroup row className="widget-setting">
                <Label className="col-sm-4">
                    { t('settings.mobile.screens.widget.settings.image_width') }
                </Label>
                <Col sm={ 8 }>
                    <PercentageField
                        name={ `mobile.screens.${screen}.widgets[${widget.index}].imageWidth` }
                    />
                </Col>
            </FormGroup>
            <FormGroup row className="widget-setting">
                <Label className="col-sm-4">
                    { t('settings.mobile.screens.widget.settings.image_height_ratio') }
                </Label>
                <Col sm={ 8 }>
                    <Field
                        component="input"
                        type="number"
                        className="form-control"
                        step={ 0.01 }
                        name={ `mobile.screens.${screen}.widgets[${widget.index}].imageHeightRatio` }
                    />
                </Col>
            </FormGroup>
        </>
    );
}

export default CarouselSettings;
